/**
 * Documentation layout wrapper
 */

import {ReactNode, useState} from 'react';
import {DocsNavbar} from './DocsNavbar';
import {DocsSidebar} from './DocsSidebar';
import {TableOfContents} from './TableOfContents';

interface DocsLayoutProps {
  children: ReactNode;
}

export function DocsLayout({children}: DocsLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <DocsNavbar onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      <div className="flex pt-14">
        {/* Sidebar - hidden on mobile, visible on desktop, sticky */}
        <div className="hidden lg:block">
          <div className="fixed left-0 top-14 bottom-0 w-64 overflow-y-auto">
            <DocsSidebar />
          </div>
        </div>
        
        {/* Mobile sidebar overlay */}
        {sidebarOpen && (
          <>
            <div
              className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 z-40 lg:hidden"
              onClick={() => setSidebarOpen(false)}
            />
            <div className="fixed left-0 top-14 bottom-0 z-50 lg:hidden">
              <DocsSidebar />
            </div>
          </>
        )}

        {/* Main content area - centered */}
        <div className="flex-1 lg:ml-64 min-h-[calc(100vh-3.5rem)]">
          <div className="flex justify-center">
            <main className="w-full max-w-3xl">
              {children}
            </main>
            {/* Table of Contents - right side */}
            <TableOfContents />
          </div>
        </div>
      </div>
    </div>
  );
}

